import script from "./ImpressumPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpressumPage.vue?vue&type=script&setup=true&lang=js"

import "./ImpressumPage.vue?vue&type=style&index=0&id=27520a6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27520a6b"]])

export default __exports__